import React, { useState, useEffect, useCallback, useRef } from "react";
import dayjs from 'dayjs';
import { PageBase } from "../../Components/PageBase";
import "./Proyecto.css"
import { useRol } from "../../Context";
import iconSvg from '../../icons/add-circle.svg';
import ojoMovil from '../../icons/eye-outline2.svg';
import flechita from '../../icons/ios-arrow-down.svg';
import addProjectImage from '../../icons/add-project.jpg'
import { FabButton } from "../../Components/FabButton";
import { NavLink, useNavigate } from "react-router-dom";
import { secureSetItem } from '../../utils/encryption';
import { getCsrfToken } from '../../utils/csrf';
import trashIcon from '../../icons/trash.svg';


function Proyecto() {

    const {
        projects,
        vacantCode,
        setVacantCode,
        companies,
        addProject,
        setProjects,
        idProject,
        setIdProject,
        project,
        setProject,
        setSelectedCompanyId,
        lengthProyectos,
        listaProyectos,
        setListaProyectos,
        resultados,
        company, setCompany,
        vacant_name, setVacant_name,
        cityP, setCity,
        state, setState,
        property_type, setProperty_type,
        type_license, setType_license,
        period_license, setPeriod_license,
        end_date, setEnd_date,
        handlePatchProyecto,
        rolOriginal,
        rolActivo,
        report_BI,
        setReport_BI,
    } = useRol();

    const navigate = useNavigate();

    useEffect(() => {
        if (rolActivo === 'Asesor') {
            navigate('/Inicio');
        }
    }, [rolActivo, navigate]);

    // Modal **WEB** agregar proyectos
    const [isModalOpenAddProject, setIsModalOpenAddProject] = useState(false);
    const openModalAddProject = () => {
        setIsModalOpenAddProject(true);
    };
    const closeModalAddProject = () => {
        setIsModalOpenAddProject(false);
        document.body.style.overflow = 'visible';
    };
    // Modal **MOVIL** agregar proyectos
    const [isModalOpenAddProjectMovil, setIsModalOpenAddProjectMovil] = useState(false);
    const openModalAddProjectMovil = () => {
        setIsModalOpenAddProjectMovil(true);
    };
    const closeModalAddProjectMovil = () => {
        setIsModalOpenAddProjectMovil(false);
        document.body.style.overflow = 'visible';
    };

    const [mostrarDiv, setMostrarDiv] = useState(false);

    const mostrarOcultarDiv = () => {
        setMostrarDiv(!mostrarDiv);
    };

    useEffect(() => {
        const projectFound = projects?.find(company => company.projects.some(project => project.vacant_code === vacantCode));
        if (projectFound) {
            setSelectedCompanyId(projectFound.id);
        }
    }, [projects, vacantCode, setSelectedCompanyId]);

    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, []);

    const [sortOrder, setSortOrder] = useState('asc');
    const [sortField, setSortField] = useState('vacant_name');

    const handleSort = (field) => {
        setSortField(field);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    useEffect(() => {
        if (companies?.length > 0) {
            setProject(prevProject => ({
                ...prevProject,
                company_id: companies[0].id
            }));
        }
    }, [companies, setProject]);

    const handleInputChange = (field, value) => {
        setProject(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    const agregarProyecto = () => {
        addProject(project)
        setProjects(prevProjects => [...prevProjects, project])
        closeModalAddProject();
    };

    const [copied, setCopied] = useState(null);
    const handleCopy = (text, key) => {
        navigator.clipboard.writeText(text);
        setCopied(key);
        setTimeout(() => setCopied(null), 1500);
    };

    const PAQUETE_OPTIONS = ['Paquete Basic', 'Paquete Premium', 'Paquete Expert'];
    const LICENCIA_OPTIONS = ['Licencia Mensual', 'Licencia Anual'];
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const [paqueteValues, setPaqueteValues] = useState({});
    const [licenciaValues, setLicenciaValues] = useState({});
    const dropdownRef = useRef(null);

    const toggleDropdown = (id, e) => {
        e.stopPropagation();
        setDropdownOpenId(prev => prev === id ? null : id);
    };

    const selectPaquete = (projectId, value) => {
        setPaqueteValues(prev => ({ ...prev, [projectId]: value }));
        setDropdownOpenId(null);
    };

    const selectLicencia = (projectId, value) => {
        setLicenciaValues(prev => ({ ...prev, [projectId]: value }));
        setDropdownOpenId(null);
    };

    useEffect(() => {
        const handleClickOutside = () => setDropdownOpenId(null);
        if (dropdownOpenId !== null) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => document.removeEventListener('click', handleClickOutside);
    }, [dropdownOpenId]);

    const [projectPanelOpen, setProjectPanelOpen] = useState(false);
    const [panelUpdateStatus, setPanelUpdateStatus] = useState(null);

    const openProjectPanel = (projectId) => {
        setIdProject(projectId);
        setProjectPanelOpen(true);
        setPanelUpdateStatus(null);
    };

    const closeProjectPanel = () => {
        setProjectPanelOpen(false);
    };

    const handleUpdateProject = () => {
        handlePatchProyecto();
        setPanelUpdateStatus('ok');
        setTimeout(() => setPanelUpdateStatus(null), 3000);
    };

    const handleDeleteProject = async () => {
        if (!idProject) return;
        const confirmed = window.confirm(`¿Eliminar el proyecto "${vacant_name}"? Esta acción no se puede deshacer.`);
        if (!confirmed) return;
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/projects/${idProject}`, {
                method: 'DELETE',
                headers: { 'X-CSRFToken': getCsrfToken() },
                credentials: 'include',
            });
            if (response.ok) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error al eliminar el proyecto:', error);
        }
    };

    const handleToggleActive = (projectId, currentActive, projectVacantCode) => {
        const newActive = !currentActive;

        // Update flat project list (used by this table)
        setListaProyectos(prev => prev.map(p => p.id === projectId ? { ...p, active: newActive } : p));

        // Update grouped projects (used by TopBar selector)
        setProjects(prev => prev?.map(company => ({
            ...company,
            projects: company.projects.map(p => p.id === projectId ? { ...p, active: newActive } : p),
        })));

        // When deactivating the currently selected project, switch to next active one
        if (!newActive && projectVacantCode === vacantCode) {
            const nextProject = projects
                ?.flatMap(company => company.projects)
                .find(p => p.vacant_code !== projectVacantCode && p.active !== false);
            if (nextProject) {
                setVacantCode(nextProject.vacant_code);
                setSelectedCompanyId(nextProject.company_id);
                secureSetItem('vacantCode', nextProject.vacant_code);
                secureSetItem('selectedCompanyId', nextProject.company_id.toString());
            }
        }

        fetch(`${process.env.REACT_APP_API_URL || ""}/api/projects/${projectId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ active: newActive }),
        })
        .then(async r => {
            if (!r.ok) {
                console.error(`[active PATCH] ${r.status}:`, await r.text());
                setListaProyectos(prev => prev.map(p => p.id === projectId ? { ...p, active: currentActive } : p));
                setProjects(prev => prev?.map(company => ({
                    ...company,
                    projects: company.projects.map(p => p.id === projectId ? { ...p, active: currentActive } : p),
                })));
            }
        })
        .catch(err => {
            console.error('[active PATCH]', err);
            setListaProyectos(prev => prev.map(p => p.id === projectId ? { ...p, active: currentActive } : p));
            setProjects(prev => prev?.map(company => ({
                ...company,
                projects: company.projects.map(p => p.id === projectId ? { ...p, active: currentActive } : p),
            })));
        });
    };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="proyecto-container">
                    <div className="indicadores-coord-wrapper">
                        <div className="indicadores-coord-header">
                            <div className="indicadores-coord-header-text">
                                <label>Gestiona tus proyectos</label>
                                <span>Agrega, edita y desactiva proyectos aquí. También puedes: mejorar el tipo de paquete, periodo de facturación, y habilitar la asignación automática de contactos a tus asesores.</span>
                            </div>
                        </div>
                    </div>
                    <div className="porlet-card">
                        <div className="equipo-table-scroll">
                            <table className="equipo-table">
                                <thead>
                                    <tr>
                                        <th className="equipo-thead-btn">
                                            <button className="add-member-btn" onClick={openModalAddProject}>
                                                <img src={iconSvg} alt="+" />
                                                Agregar proyecto
                                            </button>
                                        </th>
                                        <th className="equipo-thead-search" colSpan={6}>
                                            <div className="equipo-search-wrapper">
                                                <input
                                                    type="text"
                                                    placeholder="Buscar proyecto..."
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                />
                                                <svg className="equipo-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <circle cx="11" cy="11" r="8"></circle>
                                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                </svg>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listaProyectos?.filter((project) =>
                                        project.vacant_name.toLowerCase().includes(searchTerm.toLowerCase()))
                                        .sort((a, b) => {
                                            const getSecondWord = (str) => {
                                                const words = str.split(' ');
                                                return words.length > 1 ? words[1].toLowerCase() : '';
                                            };
                                            let aValue, bValue;
                                            if (sortField === 'period_license') {
                                                aValue = getSecondWord(a[sortField] || '');
                                                bValue = getSecondWord(b[sortField] || '');
                                            } else if (sortField === 'end_date') {
                                                aValue = new Date(a.end_date);
                                                bValue = new Date(b.end_date);
                                            } else {
                                                aValue = a[sortField] ? a[sortField].toLowerCase() : '';
                                                bValue = b[sortField] ? b[sortField].toLowerCase() : '';
                                            }
                                            if (sortField === 'end_date') {
                                                return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
                                            } else {
                                                return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                                            }
                                        })
                                        .map((project) => (
                                            <tr key={project.id}>
                                                <td className="proyecto-nombre-cell" onClick={() => openProjectPanel(project.id)}>
                                                    <div className="equipo-asesor-cell">
                                                        <div className="equipo-asesor-avatar">
                                                            {project.vacant_name?.split(' ').slice(0, 2).map(w => w[0]?.toUpperCase()).join('')}
                                                        </div>
                                                        <div className="equipo-asesor-info">
                                                            <label>{project.vacant_name}</label>
                                                            <span>{project.city || 'Sin ciudad'}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`equipo-copy-pill proyecto-id-pill${copied === `vc-${project.id}` ? ' equipo-copy-pill--copied' : ''}`}
                                                        onClick={() => handleCopy(project.vacant_code, `vc-${project.id}`)}
                                                    >
                                                        {copied === `vc-${project.id}` ? (
                                                            <>
                                                                <span className="equipo-copy-text">Copiado</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                                </svg>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="equipo-copy-text">ID de proyecto</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                                </svg>
                                                            </>
                                                        )}
                                                    </button>
                                                </td>
                                                <td>
                                                    <div className="proyecto-paquete-wrapper" ref={dropdownOpenId === project.id ? dropdownRef : null}>
                                                        <button
                                                            className="proyecto-paquete-btn"
                                                            onClick={(e) => toggleDropdown(project.id, e)}
                                                            disabled={rolActivo !== 'Administrador'}
                                                        >
                                                            <span>{paqueteValues[project.id] || project.type_license || 'Paquete'}</span>
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, transition: 'transform 0.2s', transform: dropdownOpenId === project.id ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                                <polyline points="6 9 12 15 18 9"></polyline>
                                                            </svg>
                                                        </button>
                                                        {dropdownOpenId === project.id && (
                                                            <div className="proyecto-paquete-menu" onClick={e => e.stopPropagation()}>
                                                                {PAQUETE_OPTIONS.map(option => (
                                                                    <button
                                                                        key={option}
                                                                        className={`proyecto-paquete-option${(paqueteValues[project.id] || project.type_license) === option ? ' proyecto-paquete-option--active' : ''}`}
                                                                        onClick={() => selectPaquete(project.id, option)}
                                                                    >
                                                                        {option}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="proyecto-paquete-wrapper">
                                                        <button
                                                            className="proyecto-paquete-btn"
                                                            onClick={(e) => toggleDropdown(`lic-${project.id}`, e)}
                                                            disabled={rolActivo !== 'Administrador'}
                                                        >
                                                            <span>{licenciaValues[project.id] || project.period_license || 'Licencia'}</span>
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, transition: 'transform 0.2s', transform: dropdownOpenId === `lic-${project.id}` ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                                <polyline points="6 9 12 15 18 9"></polyline>
                                                            </svg>
                                                        </button>
                                                        {dropdownOpenId === `lic-${project.id}` && (
                                                            <div className="proyecto-paquete-menu" onClick={e => e.stopPropagation()}>
                                                                {LICENCIA_OPTIONS.map(option => (
                                                                    <button
                                                                        key={option}
                                                                        className={`proyecto-paquete-option${(licenciaValues[project.id] || project.period_license) === option ? ' proyecto-paquete-option--active' : ''}`}
                                                                        onClick={() => selectLicencia(project.id, option)}
                                                                    >
                                                                        {option}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="equipo-actividad">
                                                        <span>{dayjs(project.end_date).format('DD/MM/YYYY')}</span>
                                                        <span className="equipo-actividad-label">Fecha de corte</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="equipo-actividad proyecto-nse-actividad">
                                                        {project.nse ? (
                                                            <>
                                                                <span className="proyecto-nse-empty">
                                                                    {project.nse}
                                                                    <NavLink to="/Afinidad" className="proyecto-nse-link proyecto-nse-link--gray" title="Configurar NSE">
                                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                                                            <polyline points="15 3 21 3 21 9"></polyline>
                                                                            <line x1="10" y1="14" x2="21" y2="3"></line>
                                                                        </svg>
                                                                    </NavLink>
                                                                </span>
                                                                <span className="equipo-actividad-label">Nivel Socio Económico</span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="proyecto-nse-empty">
                                                                    Sin NSE
                                                                    <NavLink to="/Afinidad" className="proyecto-nse-link" title="Configurar NSE">
                                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                                                            <polyline points="15 3 21 3 21 9"></polyline>
                                                                            <line x1="10" y1="14" x2="21" y2="3"></line>
                                                                        </svg>
                                                                    </NavLink>
                                                                </span>
                                                                <span className="equipo-actividad-label">NSE no configurado</span>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="equipo-actividad proyecto-nse-actividad">
                                                        <button
                                                            className={`proyecto-active-toggle${project.active ? ' proyecto-active-toggle--on' : ''}`}
                                                            onClick={() => handleToggleActive(project.id, project.active, project.vacant_code)}
                                                            title={project.active ? 'Desactivar proyecto' : 'Activar proyecto'}
                                                        >
                                                            <span className="proyecto-active-toggle-thumb" />
                                                        </button>
                                                        <span className="equipo-actividad-label">
                                                            {project.active ? 'Activo' : 'Inactivo'}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {projectPanelOpen && <div className="equipo-panel-overlay" onClick={closeProjectPanel} />}
            <div className={`equipo-user-panel${projectPanelOpen ? ' equipo-user-panel--open' : ''}`}>
                <div className="equipo-user-panel-header">
                    <div className="equipo-user-panel-avatar">
                        {vacant_name?.split(' ').slice(0, 2).map(w => w[0]?.toUpperCase()).join('')}
                    </div>
                    <div className="equipo-user-panel-header-info">
                        <label>{vacant_name}</label>
                        <span>{cityP}</span>
                    </div>
                    <button className="equipo-user-panel-close" onClick={closeProjectPanel}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="equipo-user-panel-body">
                    {rolActivo === 'Administrador' && (
                        <button className="btn-delete-project" onClick={handleDeleteProject} title="Eliminar proyecto">
                            <img src={trashIcon} alt="eliminar" />
                            Eliminar proyecto
                        </button>
                    )}
                    <div className="equipo-panel-field">
                        <label>Empresa</label>
                        <select value={company} onChange={e => setCompany(e.target.value)}>
                            {companies?.map(c => (
                                <option key={c.id} value={c.id}>{c.trade_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="equipo-panel-field">
                        <label>Nombre del desarrollo</label>
                        <input type="text" value={vacant_name || ''} onChange={e => setVacant_name(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Ciudad</label>
                        <input type="text" value={cityP || ''} onChange={e => setCity(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Estado</label>
                        <select value={state || ''} onChange={e => setState(e.target.value)}>
                            <option value=""></option>
                            <option value="Aguascalientes">Aguascalientes</option>
                            <option value="Baja California">Baja California</option>
                            <option value="Baja California Sur">Baja California Sur</option>
                            <option value="Campeche">Campeche</option>
                            <option value="Chiapas">Chiapas</option>
                            <option value="Chihuahua">Chihuahua</option>
                            <option value="Coahuila">Coahuila</option>
                            <option value="Colima">Colima</option>
                            <option value="Durango">Durango</option>
                            <option value="Guanajuato">Guanajuato</option>
                            <option value="Guerrero">Guerrero</option>
                            <option value="Hidalgo">Hidalgo</option>
                            <option value="Jalisco">Jalisco</option>
                            <option value="Estado de México">Estado de México</option>
                            <option value="Michoacán">Michoacán</option>
                            <option value="Morelos">Morelos</option>
                            <option value="Nayarit">Nayarit</option>
                            <option value="Nuevo León">Nuevo León</option>
                            <option value="Oaxaca">Oaxaca</option>
                            <option value="Puebla">Puebla</option>
                            <option value="Querétaro">Querétaro</option>
                            <option value="Quintana Roo">Quintana Roo</option>
                            <option value="San Luis Potosí">San Luis Potosí</option>
                            <option value="Sinaloa">Sinaloa</option>
                            <option value="Sonora">Sonora</option>
                            <option value="Tabasco">Tabasco</option>
                            <option value="Tamaulipas">Tamaulipas</option>
                            <option value="Tlaxcala">Tlaxcala</option>
                            <option value="Veracruz">Veracruz</option>
                            <option value="Yucatán">Yucatán</option>
                            <option value="Zacatecas">Zacatecas</option>
                        </select>
                    </div>
                    <div className="equipo-panel-field">
                        <label>Tipo</label>
                        <select value={property_type || ''} onChange={e => setProperty_type(e.target.value)}>
                            <option value=""></option>
                            <option value="Casa">Casa</option>
                            <option value="Departamento">Departamento</option>
                            <option value="Terreno">Terreno</option>
                        </select>
                    </div>
                    {['Coordinador', 'Administrador'].includes(rolActivo) && (
                        <div className="equipo-panel-field">
                            <label>Enlace Power BI</label>
                            <input type="url" value={report_BI || ''} onChange={e => setReport_BI(e.target.value)} placeholder="https://app.powerbi.com/..." />
                        </div>
                    )}
                    {rolActivo === 'Administrador' && <>
                        <div className="equipo-panel-field">
                            <label>Tipo de Licencia</label>
                            <select value={type_license || ''} onChange={e => setType_license(e.target.value)}>
                                <option value=""></option>
                                <option value="Paquete Basic">Paquete Basic</option>
                                <option value="Paquete Premium">Paquete Premium</option>
                                <option value="Paquete Expert">Paquete Expert</option>
                            </select>
                        </div>
                        <div className="equipo-panel-field">
                            <label>Periodo de Licencia</label>
                            <select value={period_license || ''} onChange={e => setPeriod_license(e.target.value)}>
                                <option value=""></option>
                                <option value="Licencia Mensual">Licencia Mensual</option>
                                <option value="Licencia Anual">Licencia Anual</option>
                            </select>
                        </div>
                        <div className="equipo-panel-field">
                            <label>Fecha fin de licencia</label>
                            <input type="date" value={end_date || ''} onChange={e => setEnd_date(e.target.value)} />
                        </div>
                        <div className="equipo-panel-field">
                            <label>Asignación automática</label>
                            <input type="text" placeholder="No disponible" disabled readOnly />
                        </div>
                    </>}
                    <div className="equipo-panel-actions">
                        <button className="btn-acept-modal" onClick={handleUpdateProject}>Actualizar proyecto</button>
                        {panelUpdateStatus === 'ok' && <span className="equipo-panel-feedback equipo-panel-feedback--ok">Proyecto actualizado correctamente</span>}
                        {panelUpdateStatus === 'error' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Error al actualizar el proyecto</span>}
                    </div>
                </div>
            </div>
            <div className="proyecto-movil">
                <div className="container-main-movil">
                    <div className="searchbar-project-movil">
                        <input type="search" placeholder="Buscar proyecto..." />
                    </div>
                    <div className="card-project-movil">
                        <div className="card-name-project-movil">
                            <NavLink to={'/Perfil-de-proyecto'} className='nav-links-movil'>
                                <label>Valquiria Towers</label>
                            </NavLink>
                        </div>
                        <div className="card-ojo-project-movil" onClick={mostrarOcultarDiv}>
                            <img src={ojoMovil} alt="ojoMovil" />
                        </div>
                        <div className="card-date-project-movil">
                            <label>01/01/2025</label>
                        </div>
                        {mostrarDiv && <div className="card-detail-project-movil">
                            <div className="detail-info-project-movil">
                                <label>Desarrollo</label>
                                <label>Valquiria Towers</label>
                            </div>
                            <div className="detail-info-project-movil">
                                <label>Tipo de licencia</label>
                                <label>Paquete Expert</label>
                            </div>
                            <div className="detail-info-project-movil">
                                <label>Periodo de licencia</label>
                                <label>Licencia Anual</label>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            <FabButton onClick={openModalAddProjectMovil} />
            {isModalOpenAddProject && <div className="equipo-panel-overlay" onClick={closeModalAddProject} />}
            <div className={`equipo-user-panel${isModalOpenAddProject ? ' equipo-user-panel--open' : ''}`}>
                <div className="equipo-user-panel-header">
                    <div className="equipo-user-panel-avatar" style={{ fontSize: '20px' }}>+</div>
                    <div className="equipo-user-panel-header-info">
                        <label>Agregar proyecto</label>
                        <span>Completa los datos del nuevo desarrollo</span>
                    </div>
                    <button className="equipo-user-panel-close" onClick={closeModalAddProject}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="equipo-user-panel-body">
                    <div className="equipo-panel-field">
                        <label>Empresa</label>
                        <select value={project.company_id} onChange={(e) => handleInputChange("company_id", e.target.value)}>
                            {companies?.map((company) => (
                                <option key={company.id} value={company.id}>{company.trade_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="equipo-panel-field">
                        <label>Nombre del desarrollo</label>
                        <input type="text" value={project.vacant_name} onChange={(e) => handleInputChange("vacant_name", e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Ciudad</label>
                        <input type="text" value={project.city} onChange={(e) => handleInputChange("city", e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Estado</label>
                        <select value={project.state} onChange={(e) => handleInputChange("state", e.target.value)}>
                            <option value="0"></option>
                            <option value="Aguascalientes">Aguascalientes</option>
                            <option value="Baja California">Baja California</option>
                            <option value="Baja California Sur">Baja California Sur</option>
                            <option value="Campeche">Campeche</option>
                            <option value="Chiapas">Chiapas</option>
                            <option value="Chihuahua">Chihuahua</option>
                            <option value="Coahuila">Coahuila</option>
                            <option value="Colima">Colima</option>
                            <option value="Durango">Durango</option>
                            <option value="Guanajuato">Guanajuato</option>
                            <option value="Guerrero">Guerrero</option>
                            <option value="Hidalgo">Hidalgo</option>
                            <option value="Jalisco">Jalisco</option>
                            <option value="Estado de México">Estado de México</option>
                            <option value="Michoacán">Michoacán</option>
                            <option value="Morelos">Morelos</option>
                            <option value="Nayarit">Nayarit</option>
                            <option value="Nuevo León">Nuevo León</option>
                            <option value="Oaxaca">Oaxaca</option>
                            <option value="Puebla">Puebla</option>
                            <option value="Querétaro">Querétaro</option>
                            <option value="Quintana Roo">Quintana Roo</option>
                            <option value="San Luis Potosí">San Luis Potosí</option>
                            <option value="Sinaloa">Sinaloa</option>
                            <option value="Sonora">Sonora</option>
                            <option value="Tabasco">Tabasco</option>
                            <option value="Tamaulipas">Tamaulipas</option>
                            <option value="Tlaxcala">Tlaxcala</option>
                            <option value="Veracruz">Veracruz</option>
                            <option value="Yucatán">Yucatán</option>
                            <option value="Zacatecas">Zacatecas</option>
                        </select>
                    </div>
                    <div className="equipo-panel-field">
                        <label>Tipo</label>
                        <select value={project.property_type} onChange={(e) => handleInputChange("property_type", e.target.value)}>
                            <option value="0"></option>
                            <option value="Casa">Casa</option>
                            <option value="Departamento">Departamento</option>
                            <option value="Terreno">Terreno</option>
                        </select>
                    </div>
                    {['Coordinador', 'Administrador'].includes(rolActivo) && (
                        <div className="equipo-panel-field">
                            <label>Enlace Power BI</label>
                            <input type="url" value={project.report_BI || ''} onChange={(e) => handleInputChange("report_BI", e.target.value)} placeholder="https://app.powerbi.com/..." />
                        </div>
                    )}
                    <div className="equipo-panel-actions">
                        <button className="btn-acept-modal" onClick={agregarProyecto}>Agregar proyecto</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Proyecto }